export const KEY_DELETE = 'KEY_DELETE'
export const KEY_DELETE_SUCCESS = 'KEY_DELETE_SUCCESS'
export const KEY_DELETE_FAILED = 'KEY_DELETE_FAILED'

export const STATISTICS_FETCH = 'STATISTICS_FETCH'
export const STATISTICS_FETCH_SUCCESS = 'STATISTICS_FETCH_SUCCESS'
export const STATISTICS_FETCH_FAILED = 'STATISTICS_FETCH_FAILED'

export const STATISTICS_RESET = 'STATISTICS_RESET'

export const KEYS_GET = 'KEYS_GET'
export const KEYS_GET_SUCCESS = 'KEYS_GET_SUCCESS'
export const KEYS_GET_FAILED = 'KEYS_GET_FAILED'
